  <template>
  <!-- <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
  v-model="isSidebarActiveLocal">
  
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Add Dynamic Fields for {{label}}</h4>
      <feather-icon icon="XIcon" class="cursor-pointer" @click.stop="isSidebarActiveLocal = false"/>
    </div>
    <vs-divider class="mb-0" /> -->
    <div class="py-0 p-2">
      <div class="vx-row">
        <div class="vx-col w-full">
          <form data-vv-scope="addCustomField">
            <div class="p-1">
              <vs-input
                class="w-full"
                label="Field Name"
               onkeypress="return (event.charCode !=47)"
                v-validate="'required|min:3|upCase'"
                name="attributeName"
                v-model="attribute_name"
                data-vv-validate-on="blur"
                @mouseleave="checkAttribute"
              />
              <div
                v-if="errors.has('addCustomField.attributeName')"
                style="color:red;"
                class="invalid-feedback"
              >{{ errors.first('addCustomField.attributeName') }}</div>
              <div
                v-if="showError"
                style="color:red;"
                class="invalid-feedback"
              >This field is already existing as a static field</div>
            </div>

            <div class="p-1">
              <label class="vs-input--label">Input Field types</label>
              <v-select
                v-model="input_field_type"
                :clearable="false"
                :options="inputfieldtype"
                v-validate="'required'"
                name="inputfieldtype"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />

              <div
                v-if="errors.has('addCustomField.inputfieldtype')"
                style="color:red;"
                class="invalid-feedback"
              >{{ errors.first('addCustomField.inputfieldtype') }}</div>
            </div>

            <!-- {{input_field_type}} -->
            <!-- <vs-alert v-if="input_field_type.value=='select' || input_field_type.value=='checkbox' || input_field_type.value=='radio'"  active="true"   class="mt-5" icon-pack="feather" icon="icon-star">
                  Option Values are separated by each separate line
            </vs-alert>-->
            <div class="p-1" v-if="input_field_type.value=='select' || input_field_type.value=='checkbox' || input_field_type.value=='radio'">
              <small
                style="color:#0382C9"
                v-if="input_field_type.value=='select' || input_field_type.value=='checkbox' || input_field_type.value=='radio'  || input_field_type.value=='multiselect' "
              >Notes : Distinct values should be on its own line</small>
              <br />
              <label
                v-if="input_field_type.value=='select' || input_field_type.value=='checkbox' || input_field_type.value=='radio'"
                class="vs-input--label"
              >Values</label>
            </div>
            <div class="p-1">
              <vs-textarea
                v-model="optionvalue"
                v-if="input_field_type.value=='select'
                || input_field_type.value=='checkbox' ||
                input_field_type.value=='radio' ||
                input_field_type.value=='multiselect'"
              />
            </div>
            <div class="p-1">
              <vs-textarea 
              v-model="description"
              placeholder="Please write small description for the attribute"
              height="200px"
              />
            </div>

            <vs-col vs-type="flex" vs-justify="left" vs-align="left">
              <vs-checkbox v-model="isrequired">Is Required</vs-checkbox>
            </vs-col>
          </form>
        </div>
      </div>

      <div class="vx-row mt-5">
        <div class="vx-col flex">
          <vs-button
            :disabled="showError"
            type="filled"
            style="font-size: 13.8px; padding: 9px;"
            class="ml-0"
            @click.prevent="create_dynamicfields()"
          >Create</vs-button>
        </div>
      </div>
    </div>
  <!-- </vs-sidebar> -->
</template>
          
<script>
import { createCustomField, fetchCustomStaticFields
} from '@/api/customfield'
import vSelect from 'vue-select'
import {validatorMixin} from '@/mixins/validator'

export default {
  name: 'AddSidebarDynamic',
  components:{
    vSelect
  },
  mixins:[validatorMixin],
  props:{
    label:{
      type:String,
      required:false
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    entityModel: {
      type: String,
      required: true
    }
  },

  data  () {
    return {

      addSideBar: false,
      custom_fields : [],
      attribute_name:'',
      attribute_type:'',
      isrequired:false,
      input_field_type:'',      
      optionvalue:'',
      multioptionvalue:[],
      description:'',
      inputfieldtype:[
        { label:'Text', value:'text', datatype:'varchar' },
        { label:'Text Area', value:'textarea', datatype:'text' },
        { label:'Radio Button', value:'radio', datatype:'varchar' },
        { label:'Checkbox', value:'checkbox', datatype:'varchar' },
        { label:'Dropdown', value:'select', datatype:'varchar' },
        { label:'Number', value:'number', datatype:'integer' },
        { label:'Date', value:'datetime', datatype:'datetime' },
        { label:'Boolean', value:'boolean', datatype:'boolean' },
        { label:'Multi Select', value:'multiselect', datatype:'varchar' }

      ],
      staticFields: [],
      module_id: '',
      modulename: this.$route.params.modelname,
      showError: false
    }
  },
  created () {
    // this.$validator.extend('upCase', {
    //   getMessage: () => 'One Alphabet character',
    //   validate: value => value.match(/[A-Za-z]/g) !== null
    // })
    this.fetch_module_static_column_list()
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.initdefault()
          this.$emit('closeSidebarEvent', false)
         
        }
      }
    },
    lineCount () {
      // Return number of lines using regex if not empty
      return this.optionvalue.length ? this.optionvalue.split(/\r\n|\r|\n/).length : 0
    },
    items () {
      const items = this.optionvalue.split('\n')
      return this.optionvalue !== '' && !!this.optionvalue.length ? items : []
    }
  },
  methods:{
    create_dynamicfields () {
      this.$validator.validateAll('addCustomField').then(valid => {
        if (valid) {
          const customerId = parseInt(localStorage.getItem('customer_id'))

          const data = {
            // attribute_type:this.attribute_type.value,
            attribute_type:this.input_field_type.datatype,
            attribute_name:this.attribute_name,
            is_required:this.isrequired,
            entity:this.entityModel,
            inputtype:this.input_field_type.value,
            is_collection: false,
            attribute_description:this.description,
            customerId
          }
          
          


          //this function is to remove empty line from array
          if (this.items.length > 0) {
            for (let i = 0; i < this.items.length; i++) { if (this.items[i] === '') { this.items.splice(i, 1) } }
          }


          if (
            this.input_field_type.value === 'text' ||
            this.input_field_type.value === 'textarea' ||
            this.input_field_type.value === 'number' ||
           this.input_field_type.value === 'datetime' ||
          this.input_field_type.value === 'boolean') {
            
            //it is to remove items value if the value is text 
            this.items.length = 0
            data['is_collection'] = false
          } else if (this.items.length < 1) {
           
            this.$vs.notify({
              title: 'Warning',
              text: 'Atleast One field required for option value',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'

            })
            return false
          }

          if (this.input_field_type.value === 'checkbox'  || this.input_field_type.value === 'multiselect') {
            data['is_collection'] = true
          }

          data.multivalue = this.items
          //now assignig items into 

          this.create_customfield(data)

        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Validation Field Required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    },
    async create_customfield (data) {
      
      
      let payload = data
      
      

      try {

        if (payload == 'Leads') {
          payload = 'Crm'
        }

        const { data } = await createCustomField(payload)
        
        this.$vs.notify({
          title: 'Success',
          text: 'Dynamic Field Created Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.$validator.reset()

        // data['attribute'].attribute_id = data.id
       
        // data.data.attribute.label = data.data.attribute.name

        // data.data.attribute.save = false 
        // data.data.attribute.disable = true
        
        // this.custom_fields.push(data.data.attribute)
        // 
        this.initdefaultvalues(data.data.attributes)
        

      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Something Went Wrong PLeas Try Again',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        this.initdefaultvalues()
        
      } finally {
        
      }
    },
    initdefault () {   
      this.attribute_name = ''
      this.attribute_type = ''
      this.items.length = 0
      this.optionvalue = ''
      this.input_field_type = ''
      this.isrequired = false
    },
    initdefaultvalues (obj) {
      this.attribute_name = ''
      this.attribute_type = ''
      this.items.length = 0
      this.optionvalue = ''
      this.input_field_type = ''
      this.isrequired = false
      this.$emit('closeSidebarEvent', obj)

    },
    checkAttribute () {
      const res = this.staticFields.filter((item) => {
        // eslint-disable-next-line eqeqeq
        return item.field_label == this.attribute_name
      })
      if (res.length !== 0) {
        this.showError = true
      } else {
        this.showError = false
      }
    },
    async fetch_module_static_column_list () {
      this.$vs.loading({text:'Fetching Dynamic Fields'})
      try {
        
        if (this.modulename == 'Leads') {
          this.module_id = 1
        } else if (this.modulename == 'Client') {
          this.module_id = 4
        } else if (this.modulename == 'Staff') {
          this.module_id = 38
        }

        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(this.module_id, customerId)
        this.staticFields = data.data.module_fields
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// .vs-sidebar .vs-sidebar--items{
//     overflow-y: scroll !important;
//   }

  .vs-sidebar .vs-sidebar--items {
    overflow: auto;
  }
  
.add-new-data-sidebar ::v-deep .vs-sidebar--background {
z-index: 52010;
}
.add-new-data-sidebar ::v-deep .vs-sidebar {
z-index: 52010;
width: 400px;
max-width: 90vw;
}

// .scroll-area--data-list-add-new {
//   // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
//   height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

//   &:not(.ps) {
//     overflow-y: auto;
//   }
// }

body {
  margin: 0;
}

.example-list-item {
  margin: 0;
  padding: 0 10px;
  font-size: 14px;
  line-height: 40px;
  color: #666;
  background-color: #fafafa;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #e3e3e3;
}

.example-list-item::before {
  content: "Line: ";
}

.con-vs-dialog .vs-dialog {
  z-index: 3000000000000000000000;
}
</style>
